import React from "react";
import "./SmartDownloadButton.css";
import { useTranslation } from "react-i18next";
import { logEvent } from "../firebase";
import { getDevicePlatform } from "../utils/storeRedirect";

const SmartDownloadButton = ({ appStoreUrl, playStoreUrl, gameName }) => {
  const { t } = useTranslation();
  const platform = getDevicePlatform();
  const isIOS = platform === "ios";
  const isAndroid = platform === "android";

  const handleClick = () => {
    const platform = isIOS ? "iOS" : isAndroid ? "Android" : "Unknown";

    logEvent("download_button_clicked", {
      game: gameName || "unknown_game",
      platform: platform,
    });

    if (isIOS && appStoreUrl) {
      window.open(appStoreUrl, "_blank");
    } else if (isAndroid && playStoreUrl) {
      window.open(playStoreUrl, "_blank");
    } else if (appStoreUrl && !playStoreUrl) {
      window.open(appStoreUrl, "_blank");
    } else if (playStoreUrl && !appStoreUrl) {
      window.open(playStoreUrl, "_blank");
    } else if (appStoreUrl || playStoreUrl) {
      const win = window.open();
      if (win) {
        const links = [
          appStoreUrl
            ? `<a href="${appStoreUrl}" target="_blank" style="display:block;margin:20px;font-size:20px;">Apple App Store</a>`
            : "",
          playStoreUrl
            ? `<a href="${playStoreUrl}" target="_blank" style="display:block;margin:20px;font-size:20px;">Google Play Store</a>`
            : "",
        ].join("");
        win.document.write(`
          <h1 style="font-family:sans-serif">Choose your platform:</h1>
          ${links}
        `);
      }
    }
  };

  return (
    <button className="smart-download-btn" onClick={handleClick}>
      {t("download")}
    </button>
  );
};

export default SmartDownloadButton;
